"use client"
import { useState } from "react"
import Modal from "./Modal"
import "../styles/FloorPlan.css"
// import floorbg from "../assets/images/pricing_bg.webp"
import fp1 from "../assets/images/FloorPlan1.jpeg"
import fp2 from "../assets/images/FloorPlan2.jpeg"
import fp3 from "../assets/images/FloorPlan3.jpeg"
import fp4 from "../assets/images/FloorPlan4.jpeg"
import fp5 from "../assets/images/FloorPlan5.jpeg"
import fp6 from "../assets/images/FloorPlan6.jpeg"

export default function FloorPlan() {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedImage, setSelectedImage] = useState(null)
  const [showImage, setShowImage] = useState(false)

  const plans = [
    { id: 1, name: "3 BHK", image: `${fp1}` },
    { id: 2, name: "3 BHK + Study", image: `${fp2}` },
    { id: 3, name: "3 BHK + Store + Servent Room", image: `${fp3}` },
    { id: 4, name: "4 BHK + Store", image: `${fp4}` },    
    { id: 5, name: "4 BHK + Store + Servent Room", image: `${fp5}` },
    { id: 6, name: "4 BHK + Store + Servent Room", image: `${fp6}` },
  ]

  const handleViewDetail = (image) => {
    setSelectedImage(image)
    setShowImage(false) // start with form first
    setIsModalOpen(true)
  }

  return (
    <>
      {/* <section id="floorplan" className="floor-plan" style={{backgroundImage: `url(${floorbg})`}}> */}
      <section id="floorplan" className="floor-plan">
        <h3 className="section-label">FLOOR PLAN</h3>
        <h2 className="section-title">Ultra-Luxury 3, 4 BHK Apartments</h2>

        <div className="floor-plan-grid">
          {plans.map((plan) => (
            <div key={plan.id} className="floor-plan-card">
              <img src={plan.image} alt={plan.name} />
              <button className="view-detail-btn" onClick={() => handleViewDetail(plan.image)}>
                View Detail
              </button>
              <h4>{plan.name}</h4>
            </div>
          ))}
        </div>
      </section>

      {/* pass props */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedImage={selectedImage}
        showImage={showImage}
        setShowImage={setShowImage}
      />
    </>
  )
}


// "use client"

// import { useState } from "react"
// import Modal from "./Modal"
// import "../styles/FloorPlan.css"

// const imagePath = "https://staging.deendayalplot.com/admin/public/stower/"

// export default function FloorPlan() {
//   const [isModalOpen, setIsModalOpen] = useState(false)
//   const [selectedPlan, setSelectedPlan] = useState(null)

//   const plans = [
//     {
//       id: 1,
//       name: "3 BHK",
//       image: imagePath + "/images/FloorPlan1.jpeg",
//     },
//     {
//       id: 2,
//       name: "3 BHK + Study",
//       image: imagePath + "/images/FloorPlan2.jpeg",
//     },
//     {
//       id: 3,
//       name: "3 BHK Store + Servent Room",
//       image: imagePath + "/images/FloorPlan3.jpeg",
//     },
//     {
//       id: 4,
//       name: "4 BHK + Store",
//       image: imagePath + "/images/FloorPlan4.jpeg",
//     },
//     {
//       id: 5,
//       name: "4 BHK+ Store + Servent Room",
//       image: imagePath + "/images/FloorPlan5.jpeg",
//     },
//     {
//       id: 6,
//       name: "4 BHK+ Store + Servent Room",
//       image: imagePath + "/images/FloorPlan6.jpeg",
//     },
//   ]

//   return (
//     <>
//       <section id="floorplan" className="floor-plan">
//         <h3 className="section-label">FLOOR PLAN</h3>
//         <h2 className="section-title">Ultra-Luxury 3, 4 BHK Apartments</h2>

//         <div className="floor-plan-grid">
//           {plans.map((plan) => (
//             <div key={plan.id} className="floor-plan-card">
//               <img src={plan.image || "/placeholder.svg"} alt={plan.name} />
//               <button className="view-detail-btn"  onClick={() => {
//     setSelectedPlan(plan)
//     setIsModalOpen(true)
//   }}>
//                 View Detail
//               </button>
//               <h4>{plan.name}</h4>
//             </div>
//           ))}
//         </div>
//       </section>

//       <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} plan={selectedPlan}/>
//     </>
//   )
// }


